'use client';

type GlobalErrorProps = {
  errorId?: string;
};

export default function GlobalError({ errorId }: GlobalErrorProps) {
  return (
    <main className="flex min-h-screen flex-col items-center justify-center bg-gray-50 px-4">
      <div className="max-w-md w-full text-center border border-red-100 bg-white rounded-2xl shadow-xs p-8">
        <h1 className="text-2xl font-semibold text-red-600">
          Something went wrong
        </h1>

        <p className="mt-2 text-gray-600">
          An unexpected error occurred while processing your request.
        </p>

        {errorId && (
          <div className="mt-4 text-xs text-gray-400">
            <p className="font-mono">Error ID: {errorId}</p>
          </div>
        )}

        <div className="mt-6">
          <button
            className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700 transition"
            // Full document navigation, not a soft router.push: the error
            // boundary renders over a crashed React tree, so a client-side
            // navigation reuses that torn fiber tree and throws React #310
            // ("Rendered more hooks than during the previous render") in the
            // App Router. A hard load discards the broken tree entirely.
            // `replace` (not `assign`) so Back can't return to the crashed page.
            onClick={() => {
              window.location.replace('/');
            }}
            type="button"
          >
            Go to Homepage
          </button>
        </div>
      </div>
    </main>
  );
}
